import { render, staticRenderFns } from "./meetingOrderDetail.vue?vue&type=template&id=85735cfa&scoped=true"
import script from "./meetingOrderDetail.vue?vue&type=script&lang=js"
export * from "./meetingOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./meetingOrderDetail.vue?vue&type=style&index=0&id=85735cfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85735cfa",
  null
  
)

export default component.exports